import React, { useMemo } from 'react'
import { Currency } from '@nominex/nomiswap-sdk'
import { SlAvatar } from '@shoelace-style/shoelace/dist/react'
import tw from 'twin.macro'
import styled from 'styled-components'
import useHttpLocations from 'hooks/useHttpLocations'
import { WrappedTokenInfo } from 'state/lists/hooks'
import { getTokenLogoURL } from 'utils/getTokenLogoURL'

const StyledSlAvatar = styled(SlAvatar)<{ size: string }>`
  --size: ${({ size }) => size};

  ${tw`flex items-center`}

  &::part(initials) {
    ${tw`flex items-center text-secondary`}
  }
`

export const CurrencyImage: React.FC<{
  currency: Currency
  size?: string
  className?: string
  source?: 'nominex' | 'twt'
}> = ({ currency, size = '16px', className, source }) => {
  const uriLocations = useHttpLocations(currency instanceof WrappedTokenInfo ? currency.logoURI : undefined)
  const [currencyInitials] = currency?.symbol ?? '?'

  const src: string = useMemo(() => {
    if (currency?.isToken && currency instanceof WrappedTokenInfo) {
      const [uriLocation] = uriLocations

      return uriLocation
    }

    return getTokenLogoURL(currency?.wrapped, source)
  }, [currency, source, uriLocations])

  return (
    <StyledSlAvatar image={src} initials={currencyInitials} size={size} className={`shrink-0 ${className ?? ''}`} />
  )
}
